import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import { cva } from 'class-variance-authority';
import { Loader2, X } from 'lucide-react';
import { usePortalContainer } from '../../lib/portal-container-context';
import { cn } from '../../lib/utils';
import { Button } from './button';
const modalVariants = cva('fixed left-1/2 top-1/2 w-full max-w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-xl p-10 shadow-lg bg-background text-white border border-input focus:outline-none z-1000', {
    variants: {
        variant: {
            default: '',
            success: 'text-green-900 border border-green-300 dark:text-green-100 dark:border-green-800',
            error: 'text-red-900 border dark:text-red-100'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
export function Modal(param) {
    let { title, description, children, variant, open, confirmBtnText, confirmButtonVariant, onCancel, onConfirm, isLoading, dataE2E, className, contentStyle } = param;
    const portalContainer = usePortalContainer();
    return /*#__PURE__*/ _jsx(Dialog.Root, {
        open: open,
        onOpenChange: onCancel,
        children: /*#__PURE__*/ _jsxs(Dialog.Portal, {
            container: portalContainer !== null && portalContainer !== void 0 ? portalContainer : undefined,
            children: [
                /*#__PURE__*/ _jsx(Dialog.Overlay, {
                    className: "fixed inset-0"
                }),
                /*#__PURE__*/ _jsxs(Dialog.Content, {
                    className: cn(modalVariants({
                        variant
                    }), className),
                    style: contentStyle,
                    "data-e2e": dataE2E,
                    children: [
                        /*#__PURE__*/ _jsx(Dialog.Title, {
                            className: "text-lg mb-3 font-semibold",
                            children: title
                        }),
                        description && /*#__PURE__*/ _jsx(Dialog.Description, {
                            className: "text-sm opacity-80",
                            children: description
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mt-4",
                            children: children
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-6 flex justify-end gap-2",
                            children: [
                                /*#__PURE__*/ _jsx(Dialog.Close, {
                                    asChild: true,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "outline",
                                        onClick: onCancel,
                                        disabled: isLoading,
                                        "data-e2e": dataE2E ? "".concat(dataE2E, "__CANCEL_BUTTON") : undefined,
                                        children: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: confirmButtonVariant,
                                    onClick: onConfirm,
                                    "data-e2e": dataE2E ? "".concat(dataE2E, "__CONFIRM_BUTTON") : undefined,
                                    children: isLoading ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Loader2, {
                                                className: "h-4 w-4 animate-spin"
                                            }),
                                            " Saving"
                                        ]
                                    }) : confirmBtnText !== null && confirmBtnText !== void 0 ? confirmBtnText : 'Save changes'
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Dialog.Close, {
                            asChild: true,
                            children: /*#__PURE__*/ _jsx("button", {
                                className: "absolute right-3 top-3 rounded p-1 cursor-pointer",
                                "aria-label": "Close",
                                children: /*#__PURE__*/ _jsx(X, {
                                    className: "h-4 w-4"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
